import PortableText, { TextVariant } from '@ui/Text/PortableText';
import FrequencySwitchMobile from './FrequencySwitchMobile';
import { HeroPricingType, PricingMainType } from '@lib/sanity/queries/modules/pricingMain/types';
import { GridColFullWidth, GridContainerColClasses } from '@constants/layout';
import Visuals from '@ui/Visuals/Visuals';
import cn from '@utils/cn';
import Chip from './Chip';
import FrequencySwitchDesktop from './FrequencySwitchDesktop';

export type FrequencySwitchProps = {
  data?: HeroPricingType[];
};
export type HeroPricingProps = {
  data?: PricingMainType;
};

export default function HeroPricingModule({ data }: HeroPricingProps) {
  if (!data) {
    return null;
  }
  return (
    <div className={cn('flex flex-col items-center justify-center gap-10 p-5 text-center', GridColFullWidth)}>
      {data.heroPricing?.[0]?.visuals && (
        <div className={cn(GridContainerColClasses, 'w-full')}>
          <div className="col-span-4 flex justify-center sm:col-span-6 md:col-span-8 lg:col-start-3 xl:col-span-6 xl:col-start-4">
            <Visuals data={data.heroPricing[0].visuals} className="relative z-10 w-fit object-contain" />
          </div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-2 text-center">
        <PortableText content={data.heroPricing?.[0]?.title} variant={TextVariant.TitleLG} />
        <PortableText content={data.heroPricing?.[0]?.description} variant={TextVariant.TextBlockquoteSM} />
      </div>
      {data.heroPricing?.[0].switcher && (
        <div className="relative flex w-full items-center justify-center">
          <div className="flex items-center gap-4 ">
            <div className="block lg:hidden">
              <FrequencySwitchMobile data={data.heroPricing} />
            </div>
            <div className="hidden lg:block">
              <FrequencySwitchDesktop data={data.heroPricing} />
            </div>
          </div>
          <div key={1} className="absolute right-[calc(50%-185px)] top-1/2  -translate-y-1/2 transform lg:hidden">
            <Chip data={data.heroPricing} />
          </div>
          <div key={2} className="hidden lg:right-[calc(50%-200px)] lg:block">
            <Chip data={data.heroPricing} />
          </div>
        </div>
      )}
    </div>
  );
}
